import { StanButton, StanModal } from '@/components';

interface RescheduleSuccessModalProps {
    isOpen: boolean;
    onClose: () => void;
    attendeeName: string;
}

export function RescheduleSuccessModal({ isOpen, onClose, attendeeName }: RescheduleSuccessModalProps) {
    return (
        <StanModal
            id='reschedule-success-modal'
            isOpen={isOpen}
            onClose={onClose}
            title='Meeting Successfully Rescheduled'
            size='sm'
        >
            <div className='space-y-6'>
                <p className='text-gray text-body-sm text-center'>We sent a confirmation to {attendeeName}</p>

                <StanButton name='close-success' onClick={onClose} color='primary' className='w-full'>
                    Thanks
                </StanButton>
            </div>
        </StanModal>
    );
}
